
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91id_93s_AEwhBpB3DPg_1TgklsMCqcpeERWgauKf16Jdwn0GUMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/rewards/detail/coupon/[id].vue?macro=true";
import { default as _91id_93XT6cdkT3CvPfQ5v49XTI37Imldw54XqRlifytkf0CXUMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/rewards/detail/custom/[id].vue?macro=true";
import { default as _91id_93vC5_DXJ0oyUgbtszSLySkzCX9HZYNwuGndZriEYZlykMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/rewards/detail/[id].vue?macro=true";
import { default as avatar03aFlX2SQ5n7_m9kkbiEuRmyQZRB3lms9GBhBj96jOgMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/profile/avatar.vue?macro=true";
import { default as rewardsqibbNMmpI3tRKp7IeCk0QQrVHg1PpWp9Tj8K9Z5RA4EMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/profile/rewards.vue?macro=true";
import { default as plusiqyoLxcWO9DNK0baYwfCeHuadB1sob_5ARM4U0ruN9EMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/rewards/plus.vue?macro=true";
import { default as popupXg1kAa7mIvF08tfmgdCaQXvnE_8QFGTXRGNWywDB2wIMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/preview/notifications/popup.vue?macro=true";
import { default as detailUwSivk8MkY_7F7JzsSkpb7Ogu9xPHxvwMreHkIxKsHsMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/preview/rewards/detail.vue?macro=true";
import { default as largecardCKG2iVpNEG2fsi2LP_m1lBsr77k_yB2YEdsHH_e9qqUMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/preview/rewards/largecard.vue?macro=true";
import { default as smallcardiFKJCf54vAGhJ2XlAXEl7DgKbmPuBqhHKhvRd6u7l8EMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/preview/rewards/smallcard.vue?macro=true";
import { default as specialtsToysx7eXwtNRzcrRm2uG43Mvpq5cW8XhrTH6owD9UMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/preview/specials/special.vue?macro=true";
import { default as simpleziT6_BIwZUDrKlc2r7B4IbR9VLKZvmyPTsTaQ2hbCZUMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/special/simple.vue?macro=true";
import { default as _91id_93G7J1ekWpAKJviTznBy2hSQVoGdqxWpBgjbOWZPrR91AMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/posts/[id].vue?macro=true";
import { default as _91slug_93EHT46k7DWeLgQVSjrpUoZJlLwyvOnxZMeTPqMo_fIU0Meta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/special/[slug].vue?macro=true";
import { default as _91id_93dPjg_VvIOTvwWBofnop7QtnAPUyD64hSoT1uUvNkj6oMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/voucher/[id].vue?macro=true";
import { default as _91id_93aQttI4RRyTy6_PSltjamOGTCshyfdxWiJoG1taRPa8IMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/detail/[id].vue?macro=true";
import { default as indexSBz2ZuGOUQNCAZulo_qf4egqvoKQzpAdJZxgN8bd1s8Meta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/post/[id]/index.vue?macro=true";
import { default as _91id_93DqLUDP5zWVwp2sRJn3c6b30FefMo_K8H366io4tocdUMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/reward/[id].vue?macro=true";
import { default as challengesc_Yeo_at5xBf5434nIVC6aY8QNmHXATOGchcNP3pMtsMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/viennazuckerl/app/pages/me/challenges.vue?macro=true";
import { default as faqRhDOAv75pOE2NZLRiJdskxfc9tcrfOodgWXKl_X3EaIMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/faq.vue?macro=true";
import { default as friendsYgS_VIx4Dk9AvJZSQ1oUgC3NrFO19LzDrkKj3WYXT5QMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/friends.vue?macro=true";
import { default as leaderboardo5WlHdNUy_rC5iepbg_yo_yoaxD9E6Bx_uP5T2PGCfMMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/leaderboard.vue?macro=true";
import { default as moreFriendsU_YynhCFPF2oZK4SzFzYHMDUZJKBOuxApDBTupFGSyoMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/moreFriends.vue?macro=true";
import { default as open0Vw2_QMJu8DkwNtQQDKqrz0PuCU6qxXnTLthPU_oyXAMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/open.vue?macro=true";
import { default as overviewnJUAeADHUgCJTIH1fEvjVMu3v8PLT85d35E2dkJA7WcMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/overview.vue?macro=true";
import { default as index_Qj5og4pIOaEiv41G_P_2jvOMr_4FcfNw9qPYs3hW0gMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/profile/index.vue?macro=true";
import { default as indexVP8wsx6__BZTDFwUfNdqBakQD2MFHCIqdTRGeXQCyvUMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/viennazuckerl/app/pages/me/rewards/index.vue?macro=true";
import { default as indexvjjMgivkSSEYLF6s8BSZJBrzYbqtk0iESAku3atQ8nYMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/voucher/index.vue?macro=true";
import { default as badgeFqwUR3e5HFwZYGx_5k7_BpQ7y2iPacP4MxJTkVLkCUAMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/badge.vue?macro=true";
import { default as birthdayQjMdHvRVoZ5pHU_RnLIkcoc7CgDh_5qeFRvpu57_ja4Meta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/viennazuckerl/app/pages/notification/birthday.vue?macro=true";
import { default as birthdayweekdNrj_lYdsBeHq76JAvxe6K8iAinQft_cagjhSBMc0hwMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/viennazuckerl/app/pages/notification/birthdayweek.vue?macro=true";
import { default as christmast4lGt89DIN2mbzWQ1J1pFx_xlyCZhWQ_oP37v6sQ1EcMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/viennazuckerl/app/pages/notification/christmas.vue?macro=true";
import { default as levelupCaDgtRhSNd4VY7d_ycbANqQ5lCqCOwZAKtYWLVM32XsMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/levelup.vue?macro=true";
import { default as profileWss5Xb8_gyAHxpcDB61W02a2uoZctLZXUXfnO54sz_8Meta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/profile.vue?macro=true";
import { default as registermMRrLa7Zy9dXvoV1M_MseLWEJSbNAlmzmOzEus0ustIMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/register.vue?macro=true";
import { default as specialday3j3qEkuS2ZaWxdb3m6C9rPb3iirzQwe_0FtGejSlaK8Meta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/specialday.vue?macro=true";
import { default as mainF6DXJT1mK8M8QVQi1bsLO13fCQjYpro69rFo2ZuB1zkMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/main.vue?macro=true";
import { default as prizewheelp0n3HAfxofZDGyudu4tjqgGo9UJec9AP8oIJ97O30_QMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/prizewheel.vue?macro=true";
import { default as profilek4SDRdTlMa3jJr7CwoER_K1caIih7kV28AVyg17f4AIMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/profile.vue?macro=true";
import { default as quizl8ZCkpUjFKE5v0eM_PVU8d3BXwJjU5RaHwPKAFZb0ZwMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/quiz.vue?macro=true";
import { default as indexzD5i_AduqFRFYblZ41TUwhPDRSOL4JlSGBV8YViuKjYMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/reward/index.vue?macro=true";
import { default as indexC7pglel7YGRqdIQodU2VJojWY_RmuRirxQEXjPjUiuMMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/special/index.vue?macro=true";
import { default as user_BwvKnz_awclI764K2jvuYQMkTnJ88D5EpqxWHrT3FMMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/user.vue?macro=true";
import { default as _91id_93lygRqnu2M9jfSRL6vdAGeUNqeV0mASSEhNLsLXlXZxAMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/preview/[type]/[id].vue?macro=true";
import { default as openJKfntbr9IWsEZr_cx0ITaUEXw9zH71SAImPjLBjBYT4Meta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/viennazuckerl/app/pages/open.vue?macro=true";
import { default as indexvkc2ieAkNo44JfdILBDUjnsc0stWSIQoXUBIm_KtdBoMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/index.vue?macro=true";
export default [
  {
    name: "me-rewards-detail-coupon-id",
    path: "/me/rewards/detail/coupon/:id()",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/rewards/detail/coupon/[id].vue")
  },
  {
    name: "me-rewards-detail-custom-id",
    path: "/me/rewards/detail/custom/:id()",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/rewards/detail/custom/[id].vue")
  },
  {
    name: "me-rewards-detail-id",
    path: "/me/rewards/detail/:id()",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/rewards/detail/[id].vue")
  },
  {
    name: "me-profile-avatar",
    path: "/me/profile/avatar",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/profile/avatar.vue")
  },
  {
    name: "me-profile-rewards",
    path: "/me/profile/rewards",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/profile/rewards.vue")
  },
  {
    name: "me-rewards-plus",
    path: "/me/rewards/plus",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/rewards/plus.vue")
  },
  {
    name: "preview-notifications-popup",
    path: "/preview/notifications/popup",
    meta: popupXg1kAa7mIvF08tfmgdCaQXvnE_8QFGTXRGNWywDB2wIMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/preview/notifications/popup.vue")
  },
  {
    name: "preview-rewards-detail",
    path: "/preview/rewards/detail",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/preview/rewards/detail.vue")
  },
  {
    name: "preview-rewards-largecard",
    path: "/preview/rewards/largecard",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/preview/rewards/largecard.vue")
  },
  {
    name: "preview-rewards-smallcard",
    path: "/preview/rewards/smallcard",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/preview/rewards/smallcard.vue")
  },
  {
    name: "preview-specials-special",
    path: "/preview/specials/special",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/preview/specials/special.vue")
  },
  {
    name: "widget-special-simple",
    path: "/widget/special/simple",
    meta: simpleziT6_BIwZUDrKlc2r7B4IbR9VLKZvmyPTsTaQ2hbCZUMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/special/simple.vue")
  },
  {
    name: "me-posts-id",
    path: "/me/posts/:id()",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/posts/[id].vue")
  },
  {
    name: "me-special-slug",
    path: "/me/special/:slug()",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/special/[slug].vue")
  },
  {
    name: "me-voucher-id",
    path: "/me/voucher/:id()",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/voucher/[id].vue")
  },
  {
    name: "notification-detail-id",
    path: "/notification/detail/:id()",
    meta: _91id_93aQttI4RRyTy6_PSltjamOGTCshyfdxWiJoG1taRPa8IMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/detail/[id].vue")
  },
  {
    name: "widget-post-id",
    path: "/widget/post/:id()",
    meta: indexSBz2ZuGOUQNCAZulo_qf4egqvoKQzpAdJZxgN8bd1s8Meta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/post/[id]/index.vue")
  },
  {
    name: "widget-reward-id",
    path: "/widget/reward/:id()",
    meta: _91id_93DqLUDP5zWVwp2sRJn3c6b30FefMo_K8H366io4tocdUMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/reward/[id].vue")
  },
  {
    name: "me-challenges",
    path: "/me/challenges",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/viennazuckerl/app/pages/me/challenges.vue")
  },
  {
    name: "me-faq",
    path: "/me/faq",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/faq.vue")
  },
  {
    name: "me-friends",
    path: "/me/friends",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/friends.vue")
  },
  {
    name: "me-leaderboard",
    path: "/me/leaderboard",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/leaderboard.vue")
  },
  {
    name: "me-moreFriends",
    path: "/me/moreFriends",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/moreFriends.vue")
  },
  {
    name: "me-open",
    path: "/me/open",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/open.vue")
  },
  {
    name: "me-overview",
    path: "/me/overview",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/overview.vue")
  },
  {
    name: "me-profile",
    path: "/me/profile",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/profile/index.vue")
  },
  {
    name: "me-rewards",
    path: "/me/rewards",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/viennazuckerl/app/pages/me/rewards/index.vue")
  },
  {
    name: "me-voucher",
    path: "/me/voucher",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/voucher/index.vue")
  },
  {
    name: "notification-badge",
    path: "/notification/badge",
    meta: badgeFqwUR3e5HFwZYGx_5k7_BpQ7y2iPacP4MxJTkVLkCUAMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/badge.vue")
  },
  {
    name: "notification-birthday",
    path: "/notification/birthday",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/viennazuckerl/app/pages/notification/birthday.vue")
  },
  {
    name: "notification-birthdayweek",
    path: "/notification/birthdayweek",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/viennazuckerl/app/pages/notification/birthdayweek.vue")
  },
  {
    name: "notification-christmas",
    path: "/notification/christmas",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/viennazuckerl/app/pages/notification/christmas.vue")
  },
  {
    name: "notification-levelup",
    path: "/notification/levelup",
    meta: levelupCaDgtRhSNd4VY7d_ycbANqQ5lCqCOwZAKtYWLVM32XsMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/levelup.vue")
  },
  {
    name: "notification-profile",
    path: "/notification/profile",
    meta: profileWss5Xb8_gyAHxpcDB61W02a2uoZctLZXUXfnO54sz_8Meta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/profile.vue")
  },
  {
    name: "notification-register",
    path: "/notification/register",
    meta: registermMRrLa7Zy9dXvoV1M_MseLWEJSbNAlmzmOzEus0ustIMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/register.vue")
  },
  {
    name: "notification-specialday",
    path: "/notification/specialday",
    meta: specialday3j3qEkuS2ZaWxdb3m6C9rPb3iirzQwe_0FtGejSlaK8Meta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/specialday.vue")
  },
  {
    name: "widget-main",
    path: "/widget/main",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/main.vue")
  },
  {
    name: "widget-prizewheel",
    path: "/widget/prizewheel",
    meta: prizewheelp0n3HAfxofZDGyudu4tjqgGo9UJec9AP8oIJ97O30_QMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/prizewheel.vue")
  },
  {
    name: "widget-profile",
    path: "/widget/profile",
    meta: profilek4SDRdTlMa3jJr7CwoER_K1caIih7kV28AVyg17f4AIMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/profile.vue")
  },
  {
    name: "widget-quiz",
    path: "/widget/quiz",
    meta: quizl8ZCkpUjFKE5v0eM_PVU8d3BXwJjU5RaHwPKAFZb0ZwMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/quiz.vue")
  },
  {
    name: "widget-reward",
    path: "/widget/reward",
    meta: indexzD5i_AduqFRFYblZ41TUwhPDRSOL4JlSGBV8YViuKjYMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/reward/index.vue")
  },
  {
    name: "widget-special",
    path: "/widget/special",
    meta: indexC7pglel7YGRqdIQodU2VJojWY_RmuRirxQEXjPjUiuMMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/special/index.vue")
  },
  {
    name: "widget-user",
    path: "/widget/user",
    meta: user_BwvKnz_awclI764K2jvuYQMkTnJ88D5EpqxWHrT3FMMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/user.vue")
  },
  {
    name: "preview-type-id",
    path: "/preview/:type()/:id()",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/preview/[type]/[id].vue")
  },
  {
    name: "open",
    path: "/open",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/viennazuckerl/app/pages/open.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/index.vue")
  }
]